import { servicesApi } from '../services';
import { NdaDto } from './types/responses/nda-dto.type';

const NDA_PREFIX = 'ndas';

const ndaApi = servicesApi.injectEndpoints!({
  endpoints: (build) => ({
    getNdasBySiren: build.query<string[], GetNdasBySirenQueryArgs, any>({
      query: ({ siren }) => ({
        url: `${NDA_PREFIX}/code/by-siren`,
        params: { siren },
        meta: { skipErrorToast: true },
      }),
    }),
    getNdasBySirenAndSiret: build.query<NdaDto[], GetNdasBySirenAndSiret, any>({
      query: ({ siren, siret }) => ({
        url: `${NDA_PREFIX}/code/by-siren-siret`,
        params: { siren, siret },
        meta: { skipErrorToast: true },
      }),
    }),
    getSiretBySirenAndCode: build.query<NdaDto, GetSiretByCodeAndSiren, any>({
      query: ({ siren, code }) => ({
        url: `${NDA_PREFIX}/siret`,
        params: { siren, code },
        meta: { skipErrorToast: true },
      }),
    }),
    checkIfNdaExistsBySiren: build.query<void, CheckIfNdaExistsBySirenArgs, any>({
      query: ({ siren, code }) => ({
        url: `${NDA_PREFIX}/check`,
        params: { siren, code },
        meta: { skipErrorToast: true },
      }),
    }),
  }),
});

interface GetNdasBySirenQueryArgs {
  siren: string;
}


interface GetNdasBySirenAndSiret {
  siren: string;
  siret: string;
}

interface GetSiretByCodeAndSiren {
  siren: string;
  code: string;
}

interface CheckIfNdaExistsBySirenArgs {
  siren: string;
  code: string;
}

export const {
  useLazyGetNdasBySirenQuery,
  useLazyGetNdasBySirenAndSiretQuery,
  useGetSiretBySirenAndCodeQuery,
  useCheckIfNdaExistsBySirenQuery,
} = ndaApi;